define('specific/popin-rules/views/PopinRulesView', [
    'specific/popin-rules/templates/popinrules',
    'components/factory/Factory'
], function(tpl, Factory, RowModel, RowView) {

    var PopinRulesView = Mazarine.View.extend({

        events: {},

        template: tpl,

        className: "maz-popinrules-view",

        initialize: function(){
        },

        afterRender: function() {
            this.model.set('isReady', true);
        }

    });

    return PopinRulesView;
});
